import React from 'react';
import { observer } from 'mobx-react-lite';

import WinnerHead from './winnerHead';
import WinnerContent from './winnerContent';
import { winnersStore } from '../../store/winnersStore';

const WinnerSection = observer(() => {
  const { winnersData } = winnersStore;

  return winnersData && winnersData.length ? (
    <div className='c-m-winner-wrapper'>
      <div className='c-m-winner-block'>
        <WinnerHead winnersData={winnersData} />
        <WinnerContent winnersData={winnersData} />
      </div>
    </div>
  ) : null;
});

export default WinnerSection;
